module.exports = __webpack_public_path__ + "img/pet_running.08e9bf17.png";